import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { FC } from 'react'

export type ErrorPageProps = {
    error?: FetchBaseQueryError | SerializedError
}

export const ErrorPage: FC<ErrorPageProps> = ({error}) => {
    return <div>{
        JSON.stringify(error)
    }</div>
}